import { createFileRoute, stripSearchParams } from '@tanstack/react-router';
import { zodValidator, fallback } from '@tanstack/zod-adapter';
import { z } from 'zod';

export const analyticsSearchSchema = z.object({
  graph: fallback(z.string(), 'conversations'),
  property: fallback(z.string(), 'inboxes'),
  group: fallback(z.string(), ''),
  integrations: fallback(z.string(), ''),
  afterTs: fallback(z.string(), ''),
  beforeTs: fallback(z.string(), ''),
  live: fallback(z.string(), ''),
  message_sheet: fallback(z.string(), ''),
  sheet_filters: fallback(z.string(), ''),
  selected_message: fallback(z.string(), ''),
  sheet_tab: fallback(z.string(), ''),
});

const strippableDefaults = {
  group: '',
  integrations: '',
  afterTs: '',
  beforeTs: '',
  live: '',
  message_sheet: '',
  sheet_filters: '',
  selected_message: '',
  sheet_tab: '',
};

export type AnalyticsSearch = z.infer<typeof analyticsSearchSchema>;

export const Route = createFileRoute('/_authenticated/analytics/')({
  validateSearch: zodValidator(analyticsSearchSchema),
  search: {
    middlewares: [stripSearchParams(strippableDefaults)],
  },
});
